module.exports = __webpack_public_path__ + "img/icon_qgg_01.95dcc231.png";